import { render, staticRenderFns } from "./msgImage.vue?vue&type=template&id=1c105cf3&scoped=true&"
import script from "./msgImage.vue?vue&type=script&lang=js&"
export * from "./msgImage.vue?vue&type=script&lang=js&"
import style0 from "./msgImage.vue?vue&type=style&index=0&id=1c105cf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c105cf3",
  null
  
)

export default component.exports